import diamondLogoUrl from '../../../../images/logo-diamond.png';

export const DiamondLogo = () => <img src={diamondLogoUrl} height={22} alt="Closelink" title="Closelink" />;
